// extracted by mini-css-extract-plugin
export default {"mainWrapper":"_2KvVI","content":"_1lvCs","tabs":"_1M4Vp","tab":"nNK8x","selected":"_1f2IR","widgetTitle":"_2_5wU","popularListWrapper":"_2fymL","tabsView":"u__c3"};